import React from "react";
import { Flex, Button, Box, Modal, Text } from "samba-ui";

import PropTypes from "prop-types";

const FeedStartStopModal = ({ isOpen, onClose, onSubmit, paused }) => {
  const pauseOrRestart = paused ? "Restart" : "Pause";
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Text>{pauseOrRestart} the feed</Text>
      </Modal.Header>
      <Modal.Content>
        <Box>
          <Text>Are you sure you want to {pauseOrRestart}?</Text>
        </Box>
      </Modal.Content>

      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button variant="primary" onClick={onSubmit}>
            {pauseOrRestart}
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

FeedStartStopModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  paused: PropTypes.bool.isRequired
};

export default FeedStartStopModal;
